// composables/useLanguageMessages.ts
type LanguageMessagesResult = {
    language: string
    item: {
        key: string
        value: string
    }[]
}
const languageCache = new Map<string, Record<string, string>>()

export async function useLanguageMessages(locale: string) {
    if (languageCache.has(locale)) {
        return languageCache.get(locale)!
    }
    const nuxtApp = useNuxtApp()

    const { data } = await useSanityQuery<LanguageMessagesResult[]>(getLanguage, {
        key: locale,
        language: locale,
        cacheKey: `i18n-${locale}`,
    }, {
        server: true,
        lazy: false,
        transform(input) {
            return {
                ...input,
                fetchedAt: new Date()
            }
        },
        getCachedData(key) {
            const data = nuxtApp.payload.data[key] || nuxtApp.static.data[key]
            // If data is not fetched yet
            if (!data) {
                console.log('not fetched yet')
                // Fetch the first time
                return
            }

            // Is the data too old?
            const expirationDate = new Date(data.fetchedAt)
            expirationDate.setTime(expirationDate.getTime() + 1000 * 60 * 60 * 24) // 1 day
            const isExpired = expirationDate.getTime() < Date.now()
            if (isExpired) {
                console.log('is expired')
                // Refetch the data
                return
            }

            console.log('is not expired')
            return data
        },
    })

    if (!data.value?.length) return {}

    const { item } = data.value.find((result) => result.language === locale) as LanguageMessagesResult

    const messages: Record<string, string> = {}
    item.forEach((row) => {
        if (row.key) messages[row.key] = row.value
    })

    languageCache.set(locale, messages)

    return messages
}
